const cloudpaymentsScript = document.createElement("script");
cloudpaymentsScript.setAttribute("src", "https://widget.cloudpayments.ru/bundles/cloudpayments");
document.head.appendChild(cloudpaymentsScript);
